import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { DESKTOP_SIDE_BAR_MENU } from '../../config/general.config';

function SideBar(props) {
    const [subNav, setSubNav] = useState(props.history.location.pathname.split('/')[2]);

    const handleClick = (item) => {
        if (subNav == item) {
            setSubNav('');
        } else {
            setSubNav(item);
        }
    };

    return (
        <div className='promotion-details-wrap d-flex'>
            <div className="promotion_details">
                <h4 className='sidebar-heading'>Categories</h4>
                {DESKTOP_SIDE_BAR_MENU.map((item) => {
                    return (
                        <ul>
                            <div className='tab-parent d-flex align-items-center justify-content-between' onClick={() => { handleClick(item.path.split('/')[2]); }}>
                                <div className='d-flex align-items-center'>
                                    <img src={item.iconSrc} alt="about-icon" />
                                    <span><b>{item.title} </b></span>
                                </div>
                                {(subNav == item.path.split('/')[2]) ? <i className="fas fa-chevron-up"></i> : <i className="fas fa-chevron-down"></i>}
                            </div>
                            {(subNav == item.path.split('/')[2]) && item.subNav.map((subItem, index) => {
                                let isActive = (subItem.path.split('/')[3] == props.history.location.pathname.split('/')[3]) ? 'active' : '';
                                return (
                                    <div className={`static-inner-link ${isActive}`}>
                                        <Link to={subItem.path}>
                                            <li id={index} >
                                                <span>{subItem.title}</span>
                                            </li>
                                        </Link>
                                    </div>
                                );
                            })}
                        </ul>
                    );
                })}
            </div>

        </div>
    );
}

export default SideBar;
